import Vue from 'vue'
import dialogTemplate from './msgModal';

function create(Component, props) {
   
    // 先创建实例
    const vm = new Vue({
        render(h) {
          return h(Component, {props})
        }
    }).$mount();

    
    // 手动挂载
    document.body.appendChild(vm.$el);
    const comp = vm.$children[0];
    return comp;
}

const msgModal = {
  open(props){
    let comp = create(dialogTemplate,props);
  },
  close(){
      console.log('1')
  }
}


export default msgModal;


// WEBPACK FOOTER //
// ./src/components/msgModal/modal.js